function updateActiveHeading(headings, anchorElements, lastActiveIndex = -1, offset = 50) {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let activeIndex = lastActiveIndex;

  headings.forEach((heading, index) => {
    const headingPosition = heading.getBoundingClientRect().top + window.pageYOffset;
    if (Math.abs(headingPosition - scrollTop) <= offset) {
      activeIndex = index;
    }
  });

  // Only update active state if a new heading is near the top
  if (activeIndex !== lastActiveIndex && activeIndex >= 0) {
    headings.forEach(h => h.classList.remove('active'));
    anchorElements.forEach(h => h.classList.remove('active'));

    headings[activeIndex].classList.add('active');
    if (anchorElements[activeIndex]) {
      anchorElements[activeIndex].classList.add('active');
    }
    lastActiveIndex = activeIndex;
  }
}
